import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {Message, MessageService, TreeNode} from "primeng/api";
import {AdminService} from "../../../services/data/admin.service";
import _ from "lodash";
import {Status} from 'src/app/types/sherpa';

@Component({
	selector: 'base-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

	public status: Status = null;
	public cpuData: any = null;
	public projectData: any = [];

	constructor(private route: ActivatedRoute, public toast: MessageService, private adminService: AdminService) {
	}

	ngOnInit() {

		this.adminService.getStatus().then((s: Status) => {
			this.status = s;
			this.initCpuCharts();
		});

	}

	initCpuCharts() {
		this.cpuData = [];
		let i = 0;
		_.forEach(this.status.cpuLoadStatus.cpu_load_per_processor, (d: number) => {
			i++;
			this.cpuData.push({
				labels: ['Idle', 'Load cpu ' + i + ': ' + _.round(d, 2) + '%'],
				datasets: [{
					data: [100 - d, d],
					backgroundColor: ['#f0f0f0', '#79b843'],
					hoverBackgroundColor: ['#f0f0f0', '#79b843']
				}]
			})
		});
	}

}
